import { DataSources } from "@me8eon/data_sources";

import { elasticSearch, elasticSearchAggregates, ElasticSearchContext, elasticSearchDs, ElasticSearchFilters, elasticSearchForAggregatesDs, elasticSearchKnn, elasticSearchKnnDs } from "@me8eon/elastic_search_data_sources";
import { GraphApiContext, graphApiEmailsDs, graphApiFiles, graphApiFilesDs, GraphApiFilters, graphApiPeople, graphApiPeopleDs, graphSearchAggregates } from "@me8eon/graph_api_data_sources";
import { graphApiEmails } from "@me8eon/graph_api_data_sources";
import { graphApiTeams, graphApiTeamsDs } from "@me8eon/graph_api_data_sources";

// set the data count for SharePoint data in ALL filter
const SHAREPOINT_DATA_COUNT = 3;

export function allDataSources<Filters extends ElasticSearchFilters & GraphApiFilters>(elasticSearchContext: ElasticSearchContext, graphApiContext: GraphApiContext, activeFilter: string): DataSources<Filters> {
    const graphApiFilesCount = activeFilter === "all" ? SHAREPOINT_DATA_COUNT : undefined;
    return {
        [elasticSearch]: elasticSearchDs<Filters>(elasticSearchContext),
        [elasticSearchAggregates]: elasticSearchForAggregatesDs<Filters>(elasticSearchContext),
        [elasticSearchKnn]: elasticSearchKnnDs(),
        [graphApiPeople]: graphApiPeopleDs(graphApiContext),
        [graphApiFiles]: graphApiFilesDs(graphApiContext, graphApiFilesCount),
        [graphApiEmails]: graphApiEmailsDs(graphApiContext),
        [graphApiTeams]: graphApiTeamsDs(graphApiContext),
        [graphSearchAggregates]: graphApiPeopleDs(graphApiContext),
    };
}